module.exports = __webpack_public_path__ + "static/media/190-Mobile-Banner@1x.2c25f88d.jpg";